import { getPartnerLogo } from '@components/helper';
import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { Link } from '@spark-web/link';
import { Stack, StackProps } from '@spark-web/stack';
import { BRIGHTE_SITE_DOMAIN, PACKAGE_VENDOR_CONFIG } from '@utils/constants';
import LogoImage from '../../assets/logo.svg?react';

type HeaderProps = {
  position?: StackProps['alignSelf'];
  partnerId?: string;
};

const env = import.meta.env.VITE_ENVIRONMENT as string;

export function Header({ position, partnerId }: HeaderProps) {
  const PartnerLogo = getPartnerLogo(partnerId || '');

  const brighteSiteDomain = BRIGHTE_SITE_DOMAIN[env] ?? BRIGHTE_SITE_DOMAIN['staging'];
  const { includeBrighteLogo, partnerUrl, headerPosition } = PACKAGE_VENDOR_CONFIG(partnerId);

  return (
    <Stack gap="xlarge" paddingY="xxlarge" as="header">
      <Box flex={1} justifyContent={position ?? headerPosition} display="flex" gap="medium">
        {includeBrighteLogo && (
          <Link
            href={`https://${brighteSiteDomain}`}
            aria-label="Brighte homepage"
            target="_blank"
            data={{ testId: 'logo' }}
          >
            <LogoImage aria-label="Brighte logo" />
          </Link>
        )}

        {PartnerLogo && (
          <Box display="flex" gap="medium" data-testid="partner-logo">
            {includeBrighteLogo ? <Divider vertical /> : null}
            <Link href={partnerUrl} target="_blank">
              {PartnerLogo}
            </Link>
          </Box>
        )}
      </Box>
    </Stack>
  );
}
